var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"governancePageDetail"},[(_vm.pageData)?_c('div',[(_vm.pageData.status=='success')?_c('div',{staticClass:"governance-page cms-content"},[_c('div',{attrs:{"id":"pb-content-detail"},domProps:{"innerHTML":_vm._s(_vm.$fixPbContentBefore(_vm.pageData.body))}})]):_c('missing')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }